import React, { Component } from 'react';
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import $ from 'jquery';
import {FormattedMessage} from "react-intl";

import { toggleBathroomVisualizerOpen, toggleSelectionWindow, toggleSelectionFeatureInfo,
  setVanityType } from '../../actions/actionFunctions';
import {browserIsSafari} from "../../misc/helpers";
import ProjectScopeSearchInput from "./projectScopeSearchInput";
import {getCurrentLayout} from "../appLayout";
import ProjectScopeSections from "./projectScopeSections";
import Analytics from './../../analytics';
import ProjectScopeMobileHeader from "./projectScopeMobileHeader";

class ProjectScopeMobile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      height: 0,
      shopClicked: false
    };
    this.resizeId = 0;
  }

  componentDidMount() {
    if (browserIsSafari()) {
      ['resize', 'scroll'].forEach((e) => {
        window.addEventListener(e, this.checkForResize);
      });
      setTimeout(function(){
        // Hide the address bar!
        window.scrollTo(0, 1);
      }, 150);
    }
    this.handleResize();
  }

  checkForResize = () => {
    if (!this.state.shopClicked || (window.scrollY === 0 && this.state.shopClicked)) {
      this.handleResize();
    }
  };

  handleResize = () => {
    clearTimeout(this.resizeId);
    this.resizeId = setTimeout(this.changeContainerHeight, 100);
  };

  componentWillUnmount() {
    if (browserIsSafari()) {
      ['resize', 'scroll'].forEach((e) => {
        window.removeEventListener(e, this.checkForResize);
      });
    }
  }

  changeContainerHeight = () => {
    this.setState({
      height: window.innerHeight + document.body.scrollTop
    })
  };

  handleShopClick = () => {
    this.setState({
      shopClicked: true
    }, () => {
      const $sections = $('.mscope-items');
      if ($sections) {
        $('html, body').animate({scrollTop: $sections.offset().top}, 500);
      }
    });
  };

  goToVisualizer = () => {
    this.props.toggleBathroomVisualizerOpen(true);
    this.props.setVanityType(true);
    hashHistory.push('visualizer');
  };

  searchInputChange = (searchText) => {
    this.setState({
      searchText
    });
  };

  getSearchItems = () => {
    const layout = getCurrentLayout();
    let navItems = layout.getAllFeaturesByText(this.state.searchText);
    // console.log(navItems);
    return navItems.map((navItem, index) => {
      return (
        <li className="newscope-body__list-item" key={"list-item"+index} onClick={() => this.goToItemInfo({
          part: navItem
        })}>
          {navItem.partName}
        </li>
      )
    });
  };

  goToItemInfo = (navItem) => {
    Analytics.sendClickEvent('go-to-item-info-' + navItem.part.partName);
    // console.log('navItem', navItem);
    const navItemParent = navItem.part.getParent();

    const parentSimple = (navItemParent.partName === "Floor" && navItemParent.partId !== "shower_floor")
      || navItemParent.partName === "Toilet"
      || (navItemParent.partName === "Ceiling" &&
      (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV"))
      || navItemParent.partName === "Window";
    this.props.setVanityType(true);
    this.props.toggleSelectionWindow(true, parentSimple ? navItemParent.partName : navItemParent.getParent().partName);
    hashHistory.push('materials');
    this.props.toggleSelectionFeatureInfo(navItem.part);
    navItem.part.handleClick()
  };

  render() {
    const mobileSafari = browserIsSafari();
    const selectionBodyStyles = mobileSafari ? { height: this.state.height } : {};
    return (
      <div className={"mscope" + (this.state.shopClicked ? " mscope--shop" : "")}>
        <div className="newscope" style={selectionBodyStyles}>
          {/*{mobileSafari ? <div className="test">{this.state.height}</div> : null}*/}
          <ProjectScopeMobileHeader/>
          <div className={"newscope-body newscope-body--" + document.kvConfig.visualizerType + (!this.state.searchText ? " newscope-body--empty" : "")}>
            {this.state.searchText ? (
              <ul className="newscope-body__list">
                {this.getSearchItems()}
              </ul>
            ) : null}
          </div>
          <div className="newscope-footer">
            <div className="newscope-footer__left">
              <button className="ui-button3 ui-button3--green newscope-footer__left-button"
                      onClick={this.handleShopClick}>
                <FormattedMessage id="projectScope.mobileButtonShop"/>
              </button>
            </div>
            <div className="newscope-footer__center">
              <ProjectScopeSearchInput searchInputChange={this.searchInputChange}/>
            </div>
            <div className="newscope-footer__right">
              <button className="ui-button3 ui-button3--green newscope-footer__left-button"
                      onClick={this.goToVisualizer}>
                <FormattedMessage id="projectScope.mobileButtonVisualize"/>
              </button>
            </div>
          </div>
        </div>
        {this.state.shopClicked ? (
          <div className="mscope-items">
            <ProjectScopeSections/>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    layoutParts: store.stepsState.layoutParts,
    selectionGroup: store.selectionState.selectionGroup,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  setVanityType
})(ProjectScopeMobile);
